export const DateFormatType = {
	DDMMYYYY: 'DD/MM/YYYY',
	HHMM: 'HH:mm',
	HHMMS: 'HH:mm:ss',
	DDMMYYYHHMM: 'DD/MM/YYYY HH:mm',
	DDMMYYYYHHMMS: 'DD/MM/YYYY HH:mm:ss',
} as const;
export type DateFormatType = (typeof DateFormatType)[keyof typeof DateFormatType];
